import { BaseInput, Ptag } from "components/core";
import { TpaDetailInputWrapper } from "components/Flex/styles";
import { OuterBox } from "components/GhiPlanSetup/styles";
import React, { useState } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

const OpdLimit = ({formikProps}) => {
  const [referDefault, setDefault] = useState(false)
  const handleChange = () => {
    setDefault(prevValue => !prevValue)
    formikProps.setFieldValue("opd_limit", null)
  }
  return (
    <OuterBox>
      <div style={{ marginBottom: "2rem" }}>
        <FormControlLabel
          required
          control={<Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }} onChange={()=>handleChange()}/>}
          label={
            <Ptag fontSize='16px' fontWeight='600'>Please Refer Policy Document</Ptag>
          }
        />
        <TpaDetailInputWrapper marginTop="0">
          <BaseInput
            label="OPD Limit"
            disabled={referDefault}
            formatToRupee
            fontSize="16px !imortant"
            variant="standard"
            formikProps={{
              ...formikProps,
              name: "opd_limit",
            }}
          />
        </TpaDetailInputWrapper>
      </div>
    </OuterBox>
  );
};
export default OpdLimit